export default __webpack_public_path__ + "static/media/user-circle.bce44488.svg";